/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

const highlightStyle = css`
  & strong {
    color: ${Palette.Primary._500};
    font-weight: inherit;
  }
`;

const RowGrid = styled.div`
  display: grid;
  grid-template-columns: 32px 1fr 2fr;
  gap: 20px;
`;

export const NoData = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 73px;
  color: ${Palette.PrimaryGray._500};
  background-color: white;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  border: 1px solid ${Palette.PrimaryGray._200};
  border-top: unset;
  border-bottom: unset;
`;

export const Header = styled(RowGrid)`
  position: relative;
  padding: 20px 16px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  background-color: ${Palette.PrimaryGray._000};
  color: ${Palette.PrimaryGray._500};
  border: 1px solid ${Palette.PrimaryGray._200};
  border-top: unset;
  z-index: 1;
`;

export const TableBody = styled.div`
  height: calc(100vh - 350px);
  overflow: auto;

  &::after {
    content: ' ';
    position: sticky;
    display: block;
    bottom: 0;
    width: 100%;
    height: 1px;
    background-color: ${Palette.PrimaryGray._200};
    margin-top: -1px;
  }
`;

export const Row = styled(RowGrid)`
  padding: 16px;
  font-size: 14px;
  line-height: 20px;
  background-color: white;
  color: ${Palette.PrimaryGray._500};
  border: 1px solid ${Palette.PrimaryGray._200};
  border-top: unset;
`;

export const DotMenuWrap = styled.div`
  display: flex;
  align-items: center;
  & svg {
    fill: ${Palette.PrimaryGray._500} !important;
  }
`;

export const ApplicationColumn = styled.div`
  display: flex;
  gap: 16px;
`;

export const IconWrap = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 4px;
  overflow: hidden;
  opacity: ${({ isArchived }) => (isArchived ? '0.5' : '1')};

  & svg,
  & img {
    width: 100%;
    height: 100%;
  }
`;

export const WwwTag = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${Palette.Primary._500};
  color: white;
  font-size: 7px;
  font-weight: 700;
  line-height: 1;
  padding: 2px 3px;
  border-bottom-right-radius: 3px;
`;

export const AppTitle = styled.div`
  font-weight: 500;
  color: ${Palette.PrimaryGray._700};
  display: inline-block;
  width: 23vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${highlightStyle}
`;

export const IDWrap = styled.div`
  display: flex;
  font-size: 12px;
  line-height: 16px;

  & span > span {
    color: ${Palette.PrimaryGray._700} !important;
  }
  ${highlightStyle}
`;
